/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CreateMercerStandingComment } from '@coin/shared/core/util-models-v2';
import { MercerStandingComment } from '@coin/shared/core/util-models-v2';
import { MercerStandingDetails } from '@coin/shared/core/util-models-v2';
import { MercerStandingValidationResponse } from '@coin/shared/core/util-models-v2';
import { MercerStandingValidationState } from '@coin/shared/core/util-models-v2';
import { PageOfMercerStandingActivity } from '@coin/shared/core/util-models-v2';
import { UpdateMercerStanding } from '@coin/shared/core/util-models-v2';
import { ValidateMercerStandingInput } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface GetDetailsForMeritMercerStandingsCustomerParams {
  /**  */
  employeeId: string;
  /**  */
  seasonId: string;
}

export interface GetDetailsMercerStandingsCustomerParams {
  /**  */
  employeeId: string;
}

export interface GetValidationStateMercerStandingsCustomerParams {
  /**  */
  employeeId: string;
}

export interface MercerStandingCreateMercerStandingCommentsParams {
  /** The unique id of the employee to create a comment for. */
  employeeId: string;
  /** The model data to create the comment with. */
  createMercerStandingComment?: CreateMercerStandingComment;
}

export interface MercerStandingQueryMercerStandingCommentsParams {
  /** The unique id of the employee to query comments for. */
  employeeId: string;
}

export interface QueryMercerStandingActivityStreamParams {
  /**  */
  employeeId: string;
  page?: number;
  size?: number;
}

export interface SimulateResetMercerStandingsCustomerParams {
  /**  */
  employeeId: string;
}

export interface UpdateMercerStandingsCustomerParams {
  /**  */
  employeeId: string;
  /**  */
  updateMercerStanding?: UpdateMercerStanding;
}

export interface ValidateMercerStandingsCustomerParams {
  /**  */
  employeeId: string;
  /**  */
  validateMercerStandingInput?: ValidateMercerStandingInput;
}

@Injectable({
  providedIn: 'root'
})
export class MercerStandingService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * Returns MercerStanding for employee profile details view of standing position evaluation in merit.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDetailsForMeritMercerStandingsCustomer(
    requestParameters?: GetDetailsForMeritMercerStandingsCustomerParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerStandingDetails>;
  public getDetailsForMeritMercerStandingsCustomer(
    requestParameters?: GetDetailsForMeritMercerStandingsCustomerParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerStandingDetails>>;
  public getDetailsForMeritMercerStandingsCustomer(
    requestParameters?: GetDetailsForMeritMercerStandingsCustomerParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerStandingDetails>>;
  public getDetailsForMeritMercerStandingsCustomer(
    requestParameters?: GetDetailsForMeritMercerStandingsCustomerParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('getDetailsForMeritMercerStandingsCustomer', { employeeId, seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/mercer-standing/customer/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/merit/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Returns MercerStanding for employee profile details view of standing position evaluation.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDetailsMercerStandingsCustomer(
    requestParameters?: GetDetailsMercerStandingsCustomerParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerStandingDetails>;
  public getDetailsMercerStandingsCustomer(
    requestParameters?: GetDetailsMercerStandingsCustomerParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerStandingDetails>>;
  public getDetailsMercerStandingsCustomer(
    requestParameters?: GetDetailsMercerStandingsCustomerParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerStandingDetails>>;
  public getDetailsMercerStandingsCustomer(
    requestParameters?: GetDetailsMercerStandingsCustomerParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getDetailsMercerStandingsCustomer', { employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/mercer-standing/customer/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Get MercerStanding validation state for employee profile
   * Only available for LineManager or admins
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getValidationStateMercerStandingsCustomer(
    requestParameters?: GetValidationStateMercerStandingsCustomerParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerStandingValidationState>;
  public getValidationStateMercerStandingsCustomer(
    requestParameters?: GetValidationStateMercerStandingsCustomerParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerStandingValidationState>>;
  public getValidationStateMercerStandingsCustomer(
    requestParameters?: GetValidationStateMercerStandingsCustomerParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerStandingValidationState>>;
  public getValidationStateMercerStandingsCustomer(
    requestParameters?: GetValidationStateMercerStandingsCustomerParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getValidationStateMercerStandingsCustomer', { employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/mercer-standing/customer/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/validation-state`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Creates a new employee comment for mercer standing.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public mercerStandingCreateMercerStandingComments(
    requestParameters?: MercerStandingCreateMercerStandingCommentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerStandingComment>;
  public mercerStandingCreateMercerStandingComments(
    requestParameters?: MercerStandingCreateMercerStandingCommentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerStandingComment>>;
  public mercerStandingCreateMercerStandingComments(
    requestParameters?: MercerStandingCreateMercerStandingCommentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerStandingComment>>;
  public mercerStandingCreateMercerStandingComments(
    requestParameters?: MercerStandingCreateMercerStandingCommentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('mercerStandingCreateMercerStandingComments', { employeeId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/mercer-standing/customer/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createMercerStandingComment,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Gets all comments made for this employee in mercerStanding context. This is not for a specific mercerStanding object but for the employee.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public mercerStandingQueryMercerStandingComments(
    requestParameters?: MercerStandingQueryMercerStandingCommentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<MercerStandingComment>>;
  public mercerStandingQueryMercerStandingComments(
    requestParameters?: MercerStandingQueryMercerStandingCommentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<MercerStandingComment>>>;
  public mercerStandingQueryMercerStandingComments(
    requestParameters?: MercerStandingQueryMercerStandingCommentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<MercerStandingComment>>>;
  public mercerStandingQueryMercerStandingComments(
    requestParameters?: MercerStandingQueryMercerStandingCommentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('mercerStandingQueryMercerStandingComments', { employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/mercer-standing/customer/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Returns activity stream entries for the employeeId.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryMercerStandingActivityStream(
    requestParameters?: QueryMercerStandingActivityStreamParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMercerStandingActivity>;
  public queryMercerStandingActivityStream(
    requestParameters?: QueryMercerStandingActivityStreamParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMercerStandingActivity>>;
  public queryMercerStandingActivityStream(
    requestParameters?: QueryMercerStandingActivityStreamParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMercerStandingActivity>>;
  public queryMercerStandingActivityStream(
    requestParameters?: QueryMercerStandingActivityStreamParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('queryMercerStandingActivityStream', { employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/mercer-standing/admin/api/v1/master/activity-streams/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * Simulate a reset of MercerStanding for employee profile of standing position evaluation. No actual reset is fulfilled.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulateResetMercerStandingsCustomer(
    requestParameters?: SimulateResetMercerStandingsCustomerParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerStandingDetails>;
  public simulateResetMercerStandingsCustomer(
    requestParameters?: SimulateResetMercerStandingsCustomerParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerStandingDetails>>;
  public simulateResetMercerStandingsCustomer(
    requestParameters?: SimulateResetMercerStandingsCustomerParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerStandingDetails>>;
  public simulateResetMercerStandingsCustomer(
    requestParameters?: SimulateResetMercerStandingsCustomerParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('simulateResetMercerStandingsCustomer', { employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/mercer-standing/customer/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-reset`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * &lt;p&gt;Update MercerStanding for employee profile details view of standing position evaluation.&lt;/p&gt; &lt;p&gt;Only available for lineManager or admins.&lt;/p&gt;
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateMercerStandingsCustomer(
    requestParameters?: UpdateMercerStandingsCustomerParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerStandingDetails>;
  public updateMercerStandingsCustomer(
    requestParameters?: UpdateMercerStandingsCustomerParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerStandingDetails>>;
  public updateMercerStandingsCustomer(
    requestParameters?: UpdateMercerStandingsCustomerParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerStandingDetails>>;
  public updateMercerStandingsCustomer(
    requestParameters?: UpdateMercerStandingsCustomerParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('updateMercerStandingsCustomer', { employeeId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/mercer-standing/customer/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateMercerStanding,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Check whether the position class or job code is the same or higher than that of the line manager
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public validateMercerStandingsCustomer(
    requestParameters?: ValidateMercerStandingsCustomerParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MercerStandingValidationResponse>;
  public validateMercerStandingsCustomer(
    requestParameters?: ValidateMercerStandingsCustomerParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MercerStandingValidationResponse>>;
  public validateMercerStandingsCustomer(
    requestParameters?: ValidateMercerStandingsCustomerParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MercerStandingValidationResponse>>;
  public validateMercerStandingsCustomer(
    requestParameters?: ValidateMercerStandingsCustomerParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('validateMercerStandingsCustomer', { employeeId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/mercer-standing/customer/api/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/validate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.validateMercerStandingInput,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
